function fetchData(dispatch, components, params) {
  const promises = Object.keys(components[1])
    .filter(component => components[1][component].fetchData)
    .map(component => components[1][component].fetchData(dispatch, params));

  return Promise.all(promises);
}

export default fetchData;



// WEBPACK FOOTER //
// ./fetch-data.js